import { CloseDialog } from "./CloseDialog";

export default CloseDialog;
